import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import ListItem from '@mui/material/ListItem/index';
import DeviceIcon from '#component/icon/device-icon';
import { isActiveDevice } from '#component/device/helper';
import { StyledListItemIcon, StyledListItemText } from './styles';

export default props => {
  const { device } = props;
  const meta = useSelector(s => s.meta, shallowEqual);
  const icon = meta.device?.find(m => m.name === device.type)?.icon;
  const isActive = isActiveDevice(device);
  const isExcursion = device.tempExcursion || device.humiExcursion || device.batExcursion;

  return (
    <ListItem>
      <StyledListItemIcon>
        <DeviceIcon
          icon={icon}
          isActive={isActive}
        />
      </StyledListItemIcon>
      <StyledListItemText className={isExcursion ? 'alertColor' : ''}>
        {device.title || device.uid}
      </StyledListItemText>
    </ListItem>
  );
};
